<div class="audit-history-container">
  <nz-spin [nzSpinning]="loading">
    @if (!loading && auditLogs.length === 0) {
      <nz-empty nzNotFoundContent="ისტორია არ მოიძებნა"></nz-empty>
    }

    @if (auditLogs.length > 0) {
      <nz-table
        [nzData]="auditLogs"
        [nzFrontPagination]="true"
        [nzPageSize]="10"
        nzSize="small"
        [nzShowPagination]="auditLogs.length > 10"
      >
        <thead>
          <tr>
            <th nzWidth="40px"></th>
            <th>მოქმედება</th>
            <th>შეცვალა</th>
            <th>თარიღი</th>
            <th>აღწერა</th>
          </tr>
        </thead>
        <tbody>
          @for (log of auditLogs; track log.id) {
            <tr>
              <td>
                @if (hasChanges(log)) {
                  <button
                    nz-button
                    nzType="text"
                    nzSize="small"
                    (click)="toggleRow(log.id)"
                  >
                    <span nz-icon [nzType]="isExpanded(log.id) ? 'down' : 'right'"></span>
                  </button>
                }
              </td>
              <td>
                <nz-tag [nzColor]="getActionColor(log.action)">
                  {{ getActionLabel(log.action) }}
                </nz-tag>
              </td>
              <td>{{ log.changedBy.fullName || '-' }}</td>
              <td>{{ log.timestamp | date:'dd/MM/yyyy HH:mm' }}</td>
              <td>{{ getSummary(log) }}</td>
            </tr>

            @if (isExpanded(log.id)) {
              <tr class="expanded-row">
                <td colspan="5">
                  <div class="diff-container">
                    <nz-table
                      [nzData]="getFieldChanges(log)"
                      [nzShowPagination]="false"
                      nzSize="small"
                      nzBordered
                    >
                      <thead>
                        <tr>
                          <th>ველი</th>
                          <th>ძველი მნიშვნელობა</th>
                          <th>ახალი მნიშვნელობა</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (change of getFieldChanges(log); track change.field) {
                          <tr>
                            <td><strong>{{ fieldLabels[change.field] || change.field }}</strong></td>
                            <td class="old-value">{{ formatValue(change.oldValue) }}</td>
                            <td class="new-value">{{ formatValue(change.newValue) }}</td>
                          </tr>
                        }
                      </tbody>
                    </nz-table>
                  </div>
                </td>
              </tr>
            }
          }
        </tbody>
      </nz-table>
    }
  </nz-spin>
</div>
